<template>
    <div
        class="pokemon-progress-bar"
        :class="variant === 'evolve' ? 'bar-evolve-track' : 'bar-level-track'"
        :style="{height: height + 'px'}"
    >
        <div
            class="pokemon-progress-bar-fill"
            :class="[
                variant === 'evolve' ? 'bar-evolve-fill' : 'bar-level-fill',
                {'pokemon-progress-bar-fill--pulse': percent >= pulseThreshold},
            ]"
            :style="{width: percent + '%'}"
        />
        <div
            v-if="percent > 0 && percent < 100"
            class="pokemon-progress-bar-seam"
            :style="{left: percent + '%'}"
        />
    </div>
</template>

<script>
    // 100 znamena SKUTECNE hotovo (floor()/presna-hranice logika na backendu, viz Pokemon::getEvolveProgress()/getLevelProgress())
    const PULSE_THRESHOLDS = {
        evolve: 95,
        level: 97,
    };

    export default {
        name: 'PokemonProgressBar',
        props: {
            percent: {type: Number, required: true},
            variant: {type: String, required: true, validator: (v) => v === 'evolve' || v === 'level'},
            height: {type: Number, default: 3},
        },
        computed: {
            pulseThreshold() {
                return PULSE_THRESHOLDS[this.variant];
            },
        },
    }
</script>

<style scoped>
.pokemon-progress-bar {
    position: relative;
    width: 100%;
    border-radius: 999px;
    overflow: hidden;
}
.pokemon-progress-bar-fill {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    transition: width 0.4s ease;
}
/* filter:brightness misto scale/opacity - at nehrozi oriznuti pulzujiciho okraje uvnitr overflow:hidden wrapperu */
.pokemon-progress-bar-fill--pulse {
    animation: pokemon-progress-bar-pulse 1.6s ease-in-out infinite;
}
@keyframes pokemon-progress-bar-pulse {
    0%, 100% { filter: brightness(1); }
    50% { filter: brightness(1.25); }
}
.pokemon-progress-bar-seam {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 14px;
    transform: translateX(-50%);
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.95) 50%, rgba(255,255,255,0) 100%);
    pointer-events: none;
}
</style>
